import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'

// Internal components
import Svg from '../Svg/Svg'
import Button from '../Button/Button'
import LazyImage from '../LazyImage/LazyImage'

// Utils
import getPageErrorData from '../../utils/data/getPageErrorData'
import { useContext } from 'react'
import { UserContext } from '../../context/UserContext'

const PageError = (props) => {
  const { errorCode } = props

  const userContext = useContext(UserContext)

  // Translations
  const { t } = useTranslation(
    userContext?.userSession?.sportType?.slug ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_NAMESPACE ??
      process.env.NEXT_PUBLIC_RINUS_DEFAULT_SPORT
  )

  const data = getPageErrorData(errorCode)

  return (
    data && (
      <div className={`PageError ${errorCode !== 404 ? 'PageError--fullHeight' : ''}`}>
        <div className="PageError-imageContainer">
          <LazyImage
            image={data.figure.image}
            alt={data.figure.alt}
            sizes={'100vw'}
            modifiers={['LazyImage--pageError']}
          />
        </div>
        <div className="PageError-contentContainer">
          <div className="PageError-content">
            <Svg modifiers={['PageError-icon']} id={`${errorCode === 404 ? 'icon-404' : 'icon-500'}`} />
            <div className="PageError-text">
              <p className="PageError-description">{t(data.text)}</p>
              {data.button && (
                <Button
                  href={data.button.href}
                  modifiers={data.button.modifiers}
                  label={t(data.button.label)}
                  icon={data.button.icon}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  )
}

PageError.propTypes = {
  errorCode: PropTypes.number
}

export default PageError
